import type { Root, Element, ElementContent, RootContent } from "hast";

const HEADING_TAGS = new Set(["h1", "h2", "h3", "h4", "h5", "h6"]);

function extractText(node: Element): string {
  let text = "";
  for (const child of node.children) {
    if (child.type === "text") text += child.value;
    else if (child.type === "element") text += extractText(child);
  }
  return text.trim().replace(/:$/, "").trimEnd();
}

function getCaptionText(node: ElementContent | RootContent): string | null {
  if (node.type !== "element") return null;
  if (HEADING_TAGS.has(node.tagName)) return extractText(node);
  if (node.tagName === "p") {
    const meaningful = node.children.filter((c) => !(c.type === "text" && !c.value.trim()));
    if (meaningful.length === 1) {
      const only = meaningful[0];
      if (only.type === "element" && only.tagName === "strong") {
        return extractText(only);
      }
    }
  }
  return null;
}

function findPrevSiblingIndex(children: ReadonlyArray<ElementContent | RootContent>, fromIndex: number): number {
  let i = fromIndex - 1;
  while (i >= 0) {
    const node = children[i];
    if (node.type === "text" && !node.value.trim()) {
      i--;
      continue;
    }
    return i;
  }
  return -1;
}

function transformChildren(children: Array<ElementContent | RootContent>): void {
  for (let i = 0; i < children.length; i++) {
    const curr = children[i];
    if (curr.type === "element" && curr.tagName === "table") {
      const prevIdx = findPrevSiblingIndex(children, i);
      if (prevIdx >= 0) {
        const captionText = getCaptionText(children[prevIdx]);
        if (captionText) {
          curr.children.unshift({
            type: "element",
            tagName: "caption",
            properties: {},
            children: [{ type: "text", value: captionText }],
          });
          children.splice(prevIdx, i - prevIdx);
          i = prevIdx;
        }
      }
    }
    if (curr.type === "element") {
      transformChildren(curr.children);
    }
  }
}

export function rehypeTableCaption() {
  return (tree: Root) => {
    transformChildren(tree.children);
  };
}
